<template>
    <div>
        <screen-list v-if="men.list == true" v-on:item="menu"/>
        <screen-info v-if="men.info == true" v-on:item="menu"/>
    </div>
</template>
<script>
import ScreenList from './ListMeeting.vue'
import ScreenInfo from './InfoMeeting.vue'
export default {
    components: {
        ScreenList,
        ScreenInfo,
    },
    data() {
        return {
            men: {
                list: true,
                info: false,
            },
        }
    },
    methods: {
        menu(menu) {
            this.men = menu
        }
    },
}
</script>